import "./styles/components/drawer/drawer.less"
import { ready } from "@/lib/ready";
import { on } from "@/lib/dom/on";

// ready(() => {

//   const initClick = (e: MouseEvent) => {
//     if (e.target.closest(".js-drawer__close") || e.target.classList.contains("js-drawer")) {
//       e.preventDefault();
//       closeDrawer(e.target);
//     }
//   }
//   const showDrawer = (el: HTMLElement) => {
//   }

//   const closeDrawer = (el: HTMLElement) => {
//   }
//   (document.querySelectorAll<HTMLElement>('[data-drawer]')).forEach(item => {
//     const to = item.dataset['target'];
//     if (to) {
//       const toElement = document.querySelector<HTMLElement>(to)!;
//       const closeBtnElement = toElement.querySelector('.drawer__close-btn')
//       // toElement.style.transition = 'visibility 0s .3s'

//       on(item, 'click', (e: MouseEvent) => {
//         e.preventDefault();
//         // 获取DOM元素
//         if (toElement.classList.contains('is-open')) {
//           closeDrawer();
//           toElement.classList.toggle('is-open');
//         } else {
//           showDrawer();
//           toElement.classList.toggle('is-open');
//         }
//       });

//       if (closeBtnElement) {
//         on(closeBtnElement, 'click', () => {
//           toElement.classList.remove('is-open')
//         })
//       }
//     }
//   })
// })


class Drawer {
  private element: HTMLElement;
  private content: HTMLElement | null;
  private preventScrollEl: HTMLElement | false | null;
  private triggers: NodeListOf<HTMLElement> | undefined;
  private showClass: string = 'is-open';
  private isModal = false;
  constructor(element: HTMLElement) {
    this.element = element;
    this.content = document.querySelector<HTMLElement>(".drawer__body")
    this.isModal = this.element.classList.contains("drawer--modal")
    this.triggers = document.querySelectorAll<HTMLElement>('[aria-controls="' + this.element.getAttribute("id") + '"]')

    this.preventScrollEl = this.getPreventScrollEl()
    this.initDrawer();
  }
  getPreventScrollEl (): HTMLElement | false | null {
    const attrName = this.element.getAttribute("data-drawer-prevent-scroll");
    if (attrName) {
      return document.querySelector<HTMLElement>(attrName)
    } else {
      return false
    }
  }

  showDrawer () {
    const me = this
    if (this.content) {
      this.content.scrollTop = 0
    }
    this.element.classList.add(this.showClass)
    this.element.addEventListener("transitionend", function onTransitionEnd (t) {
      me.element.removeEventListener("transitionend", onTransitionEnd)
    })

    if (this.preventScrollEl) {
      this.preventScrollEl.style.overflow = "hidden"
    }
  }

  closeDrawer (el: HTMLElement) {
    this.element.classList.remove(this.showClass)
    this.cancelDrawerEvents()

    if (this.preventScrollEl) {
      this.preventScrollEl.style.overflow = ""
    }
  }
  initDrawer () {
    const me = this;

    if (this.triggers) {
      for (let i = 0; i < this.triggers.length; i++)
        this.triggers[i].addEventListener("click", function (e) {
          e.preventDefault();
          if (me.element.classList.contains(me.showClass)) {
            me.closeDrawer(e.target as HTMLElement)
          } else {
            me.showDrawer();
            me.initDrawerEvents()
          }
        });
    }
    if (this.element.classList.contains(this.showClass)) {
      this.initDrawerEvents()
    }

  }

  initDrawerEvents () {
    this.element.addEventListener("keydown", this)
    this.element.addEventListener("click", this)
  }

  cancelDrawerEvents () {
    this.element.removeEventListener("keydown", this)
    this.element.removeEventListener("click", this)
  }
  // 实现 handleEvent 方法
  handleEvent (event: Event) {
    switch (event.type) {
      case "click":
        this.initClick(event as MouseEvent);
      case "keydown":
        this.initKeyDown(event as KeyboardEvent)
    }
  }
  initClick (e: MouseEvent) {
    const target = e.target as HTMLElement
    if (target!.closest(".drawer__close") || target!.classList.contains("drawer")) {
      e.preventDefault();
      this.closeDrawer(target as HTMLElement)
    }
  }
  initKeyDown (e: KeyboardEvent) {
  }
}


ready(() => {
  var drawerEls = document.querySelectorAll<HTMLElement>(".drawer");
  if (0 < drawerEls.length) {
    for (let i = 0; i < drawerEls.length; i++)
      new Drawer(drawerEls[i])
  }
})
export default Drawer
